import i18next from 'i18next';

import alerts from 'common/modules/alerts';

import deletePanel from './deletePanel';

export default (filterData, panelId, panelName) => (dispatch) => {
    const dataAlert = {
        confirmText: i18next.t('Continue'),
        haveTextCaptcha: true,
        messages: [
            i18next.t('Are you sure to remove the item "{{name}}"?', {
                context: 'remove',
                name: panelName,
            }),
        ],
        onSuccess: () => dispatch(deletePanel(filterData, panelId)),
        textToValidate: i18next.t('Remove').toUpperCase(),
        title: i18next.t('Confirmation'),
        type: alerts.ALERT_TYPE_CONFIRM,
        variant: 'warning',
    };

    dispatch(alerts.actions.show(dataAlert));
};
